import React, { MouseEvent } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { NameEmailAvatar } from '../../../../ui';
import { TableColumn } from '../../../../ui/components/Common/DataTable/Table';
import { ContextMenuButton } from '../../../../ui/components/Common/ContextMenu/ContextMenuButton';
import { TooltipWrapper } from '../../../job_openings/view/Functions';
import type { IOrgUser } from '../interfaces';

export const getOrganizationUserColumns = (
  onOpenMenu: (e: MouseEvent<HTMLButtonElement>, row: unknown) => void,
  onCloseMenu: () => void,
  anchorEl: HTMLElement | null,
  selectedUser: IOrgUser | null,
): TableColumn<IOrgUser>[] => [
  {
    key: 'name',
    label: 'User',
    width: '250px',
    align: 'left',
    render: (row: IOrgUser) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <NameEmailAvatar avatar="" name={row.name} email={row.email} />
      </Box>
    ),
    disableSort: true,
  },
  {
    key: 'role',
    label: 'Role',
    width: '120px',
    align: 'left',
    render: (row: IOrgUser) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', textAlign: 'left' }}>
        <Chip
          label={row.role}
          size="small"
          sx={{
            fontWeight: 800,
            fontSize: '0.625rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            borderRadius: 2,
            height: 22,
          }}
        />
      </Box>
    ),
    disableSort: true,
  },
  {
    key: 'status',
    label: 'Status',
    width: '120px',
    align: 'left',
    render: (row: IOrgUser) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: row.status === 'Active' ? 'success.main' : 'text.disabled',
            boxShadow: row.status === 'Active' ? '0 0 8px rgba(16, 185, 129, 0.5)' : 'none',
          }}
        />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: row.status === 'Active' ? 'success.main' : 'text.disabled',
          }}
        >
          {row.status}
        </Typography>
      </Box>
    ),
    disableSort: true,
  },
  {
    key: 'joined',
    label: 'Joined',
    width: '120px',
    align: 'left',
    render: (row: IOrgUser) => <TooltipWrapper text={row.joined} />,
    disableSort: true,
  },
  {
    key: 'actions',
    label: 'Actions',
    width: '80px',
    align: 'right',
    render: (row: IOrgUser) => (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', pr: 1 }}>
        <ContextMenuButton
          row={row}
          onOpenMenu={onOpenMenu}
          onCloseMenu={onCloseMenu}
          anchorEl={selectedUser?.id === row.id ? anchorEl : null}
        />
      </Box>
    ),
    disableSort: true,
  },
];
